module.exports = __webpack_public_path__ + "static/posz-de29aa8396196e4b040cd5305e351dbe.jpg";